export const NAME = 'multi-currency';
